import React from "react";
import styled from "styled-components";
import Container from "src/react/layout/container";
import { color } from "src/styles/variables";

function Intro() {
  return (
    <section>
      <Title>
        <Container>A Smooth, Comfortable Shave - Delivered.</Container>
      </Title>
      <IntroText>
        <InnerIntroText>
          <Subtitle>Hey there!</Subtitle>
          <p>
            Welcome to Cornerstone. We're here to guarantee you a smooth,
            comfortable shave every morning. We also promise that you’ll never
            have to shop for bathroom toiletries ever again.
          </p>
        </InnerIntroText>
      </IntroText>
    </section>
  );
}

export default Intro;

const mediumBreakPoint = "@media (min-width: 768px)";
const smallBreakPoint = "@media (min-width: 460px)";

const Title = styled.h1`
  font-size: 26px;
  font-weight: 600;
  line-height: 1;
  background-color: ${color.red};
  color: ${color.white};
  text-align: center;
  padding-top: 20px;
  padding-bottom: 20px;
  ${smallBreakPoint} {
    font-size: 30px;
  }
`;

const Subtitle = styled.h2`
  font-size: 36px;
  line-height: 1.5;
  font-weight: 600;
  margin-bottom: 10px;
`;

const IntroText = styled.div`
  background-color: ${color.lightGrey};
  padding-top: 20px;
  padding-bottom: 20px;
  ${mediumBreakPoint} {
    padding-top: 40px;
    padding-bottom: 40px;
  }
`;

const InnerIntroText = styled(Container)`
  text-align: center;
  max-width: 800px;
`;
